import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Button, Drawer, Grid, Typography } from '@material-ui/core/';
import BlockIcon from '@material-ui/icons/Block';

const useStyles = makeStyles((theme) => ({
	tempDrawerContainer: {
		width: '25em',
		padding: theme.spacing(2),
		'& svg': { verticalAlign: 'middle' },
	},
	gridRoot: { height: '90%' },
	body: { flexGrow: 2 },
	cancel: { marginTop: theme.spacing(2) },
}));

const CustomTempDrawer = (props) => {
	const classes = useStyles();
	// Handle close
	const handleClose = () => {
		props.setOpen(false);
	};
	// primary button click
	const handlePrimaryButtonClick = () => {
		props.primaryButtonClick();
	};
	const handleCancelBtnClick = () => {
		props.setOpen(false);
	};

	return (
		<div data-cy="custom-temp-drawer">
			<Drawer
				anchor="right"
				open={props.open}
				variant="temporary"
				onClose={handleClose}
				classes={{ paper: classes.tempDrawerContainer }}
			>
				<Grid className={classes.gridRoot} container direction="column" spacing={2}>
					<Grid item>
						<Typography variant="h4">{props.header}</Typography>
					</Grid>
					<Grid item>
						<Typography variant="body2">{props.confirmationMessage}</Typography>
					</Grid>
					<Grid className={classes.body} item>
						{props.drawerBody}
					</Grid>
					<Grid item>
						<Button
							variant="contained"
							color="primary"
							fullWidth={true}
							data-cy="temp-drawer-primary-btn"
							startIcon={props.primaryBtnStartIcon}
							onClick={handlePrimaryButtonClick}
						>
							{props.primaryBtnTxt}
						</Button>
					</Grid>
					<Grid item>
						<Button
							className={classes.cancel}
							variant="outlined"
							color="default"
							fullWidth={true}
							startIcon={<BlockIcon />}
							data-cy="temp-drawer-cancel-btn"
							onClick={handleCancelBtnClick}
						>
							Cancel
						</Button>
					</Grid>
				</Grid>
			</Drawer>
		</div>
	);
};

export default CustomTempDrawer;
